import { SxProps } from '@mui/system'
import { theme } from 'src/providers/ThemeProvider'

export const connectionChipStyles = (isConnectedToLexnet: boolean): SxProps => ({
  alignItems: 'center',
  backgroundColor: isConnectedToLexnet ? theme.colors.white01 : theme.corporate.primaryColor,
  borderRadius: '4px',
  cursor: 'pointer',
  color: isConnectedToLexnet ? theme.corporate.primaryColor : theme.palette.secondary.main,
  display: 'flex',
  fontFamily: theme.fonts.interFont,
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '22px',
  margin: theme.spacing(0, '6px'),
  padding: theme.spacing(1, 1.5, 1, 1.5),
  border: isConnectedToLexnet ? `1px solid ${theme.corporate.primaryColor}` : 'none',

  '&.Mui-disabled .MuiSvgIcon-root': {
    fill: theme.colors.gray600
  },

  // '&.onlyConnect': {
  //   '&:hover': {
  //     backgroundColor: isConnectedToLexnet ? theme.colors.blue08 : theme.colors.blue02,
  //     color: isConnectedToLexnet ? theme.corporate.primaryColor : theme.palette.secondary.main,

  //     '& .MuiSvgIcon-root': {
  //       fill: isConnectedToLexnet ? theme.corporate.primaryColor : theme.palette.secondary.main
  //     }
  //   }
  // },

  '& .MuiSvgIcon-root': {
    fontSize: 22,
    marginTop: theme.spacing(-0.375)
  },

  '& .MuiBox-root': {
    marginRight: theme.spacing(1)
  }
})
